import React from 'react'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import DynamicTick from 'widgets/DynamicTick'

export default function BarChartWidget ({
  bars = [],
  data = [],
  xTick = {},
  yTick = {},
  xDataKey = 'date',
  tooltipContent,
  children
}) {
  return (
    <ResponsiveContainer>
      <BarChart data={data} margin={{ top: 15, right: 0, bottom: 10, left: 0 }}>
        <CartesianGrid
          vertical={false}
          stroke='#ccc'
        />
        <Tooltip content={tooltipContent} />
        <XAxis
          axisLine={false}
          tickLine={false}
          dataKey={xDataKey}
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          unit=''
          tick={<DynamicTick type='number' {...yTick} />}
          tickFormatter={val => parseFloat(val).toLocaleString()}
        />
        {bars.map(bar => (
          <Bar
            barSize={15}
            key={bar.dataKey}
            fill='#8884d8'
            {...bar}
          />
        ))}
        {children}
      </BarChart>
    </ResponsiveContainer>
  )
}
